import { StatsigAction, StatsigActionType } from '../actions/statsig';
import { StatsigNamespace } from '../state/statsig';

export const statsigReducer = (
    state: StatsigNamespace = {
        experiments: {},
    },
    action: StatsigAction,
): StatsigNamespace => {
    switch (action.type) {
        case StatsigActionType.saveExperimentData:
            return {
                ...state,
                experiments: {
                    ...state.experiments,
                    [action.payload.name]: action.payload,
                },
            };
        default:
            return state;
    }
};
